import { Capacitor } from '@capacitor/core';
import { BackendInstances, FirebaseInstances } from './frontend-get-backend.interfaces';

declare const process: {
  env: {
    LOCAL_IP: string;
    PORT: string;
    NODE_ENV: string;
    NATIVE_APP_HOST_URL: string;
  };
};

const firebaseToBackEndInstances = {
  [FirebaseInstances.STAGING]: BackendInstances.STAGING,
  [FirebaseInstances.STAGING_TABLESREADY]: BackendInstances.STAGING,
  [FirebaseInstances.DOCKMAGIC_PROD]: BackendInstances.DOCKMAGIC_PROD,
  [FirebaseInstances.APP_DOCKMAGIC]: BackendInstances.DOCKMAGIC_PROD,
  [FirebaseInstances.TABLESREADY_PROD]: BackendInstances.TABLESREADY_PROD,
  [FirebaseInstances.HOST_TABLESREADY]: BackendInstances.TABLESREADY_PROD,
  [FirebaseInstances.APP_TABLESREADY]: BackendInstances.TABLESREADY_PROD,
};

const backendToFirebaseInstances = {
  [BackendInstances.STAGING]: FirebaseInstances.STAGING_TABLESREADY,
  [BackendInstances.TABLESREADY_PROD]: FirebaseInstances.HOST_TABLESREADY,
};

export function getFirebaseInstance(): string {
  let firebaseInstance = window.location.origin;

  if (
    Capacitor.isNativePlatform() &&
    process.env.NODE_ENV === 'production' &&
    process.env.NATIVE_APP_HOST_URL !== undefined
  ) {
    firebaseInstance = `https://${backendToFirebaseInstances[process.env.NATIVE_APP_HOST_URL]}`;
  }

  return firebaseInstance;
}

export function getBackEndInstance(): string {
  let backendInstance = '';
  const origin = window.location.origin;
  const regex = new RegExp('-pr-[0-9]+');

  for (let [key, value] of Object.entries(firebaseToBackEndInstances)) {
    if (origin.includes(key) && regex.test(origin)) {
      const matchedValue = origin.match(regex)[0];
      backendInstance = BackendInstances.TEST_STAGING + matchedValue + '.herokuapp.com';
      break;
    }

    if (origin.includes(key)) {
      backendInstance = value;
      break;
    }
  }

  return backendInstance;
}
